import { Button } from "@fc/devteam-components-library";
import Modal from '@material-ui/core/Modal/Modal';
import { useTranslation } from 'react-i18next';

type DeleteModalPropsType = {
    openModal: boolean;
    setOpenModal: (value: boolean) => void;
    onDeleteRow: () => void;
};

export default function DeleteModal(props: DeleteModalPropsType) {
    //Get translation object
    const { t } = useTranslation(['publicProfile']);
    return (
        <Modal open={props.openModal}>
            <div className="modal-primary delete-modal">
                    <div className="modal-primary__header">
                        <p className="Title5">
                            {t('certificationAndAwards.modal.header')}
                        </p>
                        <i
                            className="far fa-times"
                            onClick={() => props.setOpenModal(false)}
                        />
                    </div>
                    
                    <div className="Body2">
                        {t('certificationAndAwards.modal.deleteMessage')}
                    </div>
                    
                    <div className="ServicesModal__FlexContent">
                        <div className="Services__FlexAddItem">
                            <div className="Services__ButtonCtr">
                                <div onClick={props.onDeleteRow}>
                                    <Button
                                        buttontype="button"
                                        buttontext={t(
                                            'certificationAndAwards.modal.yes'
                                        )}
                                    />
                                </div>
                                <div onClick={() => props.setOpenModal(false)}>
                                    <Button
                                        buttontype="button"
                                        buttontext={t(
                                            'certificationAndAwards.modal.no'
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </Modal>
    );
}
